import {registerRoute as workbox_routing_registerRoute} from '/Users/adamt/Repos/app3/builds/certwise-common/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/Users/adamt/Repos/app3/builds/certwise-common/node_modules/workbox-strategies/NetworkFirst.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/Users/adamt/Repos/app3/builds/certwise-common/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/Users/adamt/Repos/app3/builds/certwise-common/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Users/adamt/Repos/app3/builds/certwise-common/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/cdn/certwise-common/js/@dojo/loader/loader.js",
    "revision": "f66a38c73e036053cd0d1f928cb24e38"
  },
  {
    "url": "/cdn/certwise-common/js/core-js/polyfill.js",
    "revision": "149d609e92b0f722f6318e724ee932bd"
  },
  {
    "url": "/cdn/certwise-common/js/main.409cecf36e7589edfcf2.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_dojo_widgets_calendar_nls_zh-CN_Calendar_mjs.164554b2a6f2c8e2870d.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_dojo_widgets_calendar_nls_zh-TW_Calendar_mjs.676e357eecf62cf8981f.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_dojo_widgets_dialog_nls_zh-CN_Dialog_mjs.5061a72b0aacc3ea319c.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_dojo_widgets_dialog_nls_zh-TW_Dialog_mjs.8ef58e1d9c48478fa68d.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_fr-CA_DateInput_js.34c3c7637ff848cd79cc.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_zh-CN_DateInput_js.60b6c20c4ec1b908020d.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_zh-TW_DateInput_js.463b5460f11a6b8afaa2.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_sliding-pane_nls_zh-CN_index_js.41a04fb34499425f56e1.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_sliding-pane_nls_zh-TW_index_js.0c131df17533ebe2e1c1.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_tab-container_nls_zh-CN_index_js.3d9e2561dce4a05ec6c8.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_tab-container_nls_zh-TW_index_js.36d0f9c3b6f2eb34397b.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_search-widget_main_js.a49cee9656e07d7fe543.js",
    "revision": null
  }
], {});




workbox_routing_registerRoute(/.+\/$/, new workbox_strategies_NetworkFirst({ "cacheName":"certwise-common-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\/js\/sitestart\.js$/, new workbox_strategies_NetworkFirst({ "cacheName":"certwise-common-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\.(?:jpg|jpeg|png|svg|ttf|woff|woff2|eot|ico)$/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"certwise-common-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\.css$/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"certwise-common-site", plugins: [] }), 'GET');




